//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Constants ----------------------
import { ActionTypes } from "store/constants";

const payload = [];

export const wordBankReducer = (state = payload, action) => {
  switch (action.type) {
    case ActionTypes.wordBank.setWordBank:
      return action.payload;
    case ActionTypes.wordBank.addWordBank:
      return [...state, action.payload];
    case ActionTypes.wordBank.deleteWordBank:
      return state.filter((word) => word.id !== action.payload);
    case ActionTypes.wordBank.updateWordBank:
        return state.map((word) => (word.id === action.payload.id ? action.payload : word));
    default:
      return state;
  }
};
